import { LocalDate } from '../../../utilities/local-date';

export function _formatDate(value: string | Date | undefined | null): string {
  if (value === undefined || value === null) {
    return 'Uten dato';
  } else if (typeof value === 'string') {
    if (value === '') {
      return 'Uten dato';
    } else {
      return LocalDate.fromString(value).toStringForDisplay();
    }
  } else {
    return LocalDate.fromString(value.toISOString()).toStringForDisplay();
  }
}
